import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { MultiSelectList } from 'src/domains/common/components/multi-select-list/multi-select-list';
import { CompetitionPickerState } from './CompetitionPicker.state';

interface CompetitionPickerPropType {
    competitionPickerState: CompetitionPickerState;
}

export const CompetitionPicker = observer('CompetitionPicker', (props: CompetitionPickerPropType): JSX.Element => {
    const {
        expanded,
        filteredNodes,
        keywordInputState,
        checked,
        isLoading,
        clearChecked,
        handleCheck,
        handleExpand,
        setKeyword,
    } = props.competitionPickerState;

    return (
        <div className='flex flex-col gap-2 relative'>
            {isLoading && (
                <div className='absolute top-0 left-0 right-0 bottom-0 flex flex-col items-center justify-center flex-auto gap-6 p-6 bg-white/75 font-tertiary flex-nowrap animate-pulse'>
                    <div className='w-8 h-8 border-4 border-dashed rounded-full animate-spin border-foreground' />
                </div>
            )}
            <MultiSelectList
                filteredNodes={filteredNodes}
                showAllBadges={false}
                checked={checked}
                visibleChecked={{ display: [], remaining: 0 }}
                keywordInputState={keywordInputState}
                expanded={expanded}
                visibleCheckedWithLabels={[]}
                toggleShowAllBadges={() => {}}
                clearChecked={clearChecked}
                handleCheck={handleCheck}
                handleExpand={handleExpand}
                setKeyword={setKeyword}
                handleRemoveChecked={() => {}}
                remaining={0}
                remainingLabel='Items'
                disabled={false}
                noCascade={false}
            />
        </div>
    );
});
